import { render, staticRenderFns } from "./CardActivity.vue?vue&type=template&id=d063d1f8&"
import script from "./CardActivity.vue?vue&type=script&lang=js&"
export * from "./CardActivity.vue?vue&type=script&lang=js&"
import style0 from "./CardActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports